import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';

import { UnidadeMedidaService } from '../services/unidade-medida.service';

@Component({
	selector: 'app-unidades-medida-edit',
	templateUrl: './unidades-medida-edit.component.html',
	styleUrls: ['./unidades-medida-edit.component.css'],
	animations: [loadingFade]
})
export class UnidadesMedidaEditComponent implements OnInit {
	public loading;
	public submitting = false;
	public unidade_medida_id = null;

	public formUnidadeMedida: FormGroup;

	constructor(private route: ActivatedRoute,
				private fb: FormBuilder,
				private unidMedidaSvc: UnidadeMedidaService,
				private router: Router) { }

	ngOnInit() {
		this.criaForm();

		this.loading = true;

		this.route.params.subscribe( params => {
			if (params.id) {
				this.unidade_medida_id = params.id;
				// pega dados a partir do id
				this.unidMedidaSvc.getUnidadeMedida(params.id).then((data: any) => {
					this.preencheForm({
						unidade_medida_id: data.unidade_medida_id,
						unidade_medida_nome: data.unidade_medida_nome,
						unidade_medida_codigo: data.unidade_medida_codigo
					});

					this.loading = false;
				});
			}
			else {
				this.loading = false;
			}
		});
	}

	criaForm() {
		this.formUnidadeMedida = this.fb.group({
			unidade_medida_id: null,
			unidade_medida_nome: ['', Validators.required],
			unidade_medida_codigo: ''
		});
	}

	preencheForm(dados) {
		this.formUnidadeMedida.setValue(dados);
	}

	enviaUnidadeMedida() {
		if (this.formUnidadeMedida.valid) {
			this.submitting = true;

			let toSend = this.formUnidadeMedida.value;

			if (this.unidade_medida_id === null) { // criar
				this.unidMedidaSvc.criaUnidadeMedida(toSend).then((data) => {
					console.log('resp', data);
					this.router.navigate(['home/unidadesmedida']);
				}).catch(err => {
					console.log(err);
				});
			}
			else { // editar
				this.unidMedidaSvc.editaUnidadeMedida(toSend).then((data) => {
					console.log('resp', data);
					this.router.navigate(['home/unidadesmedida']);
				}).catch(err => {
					console.log(err);
				});
			}
		}
	}

	invalid(nome) {
		let input = this.formUnidadeMedida.get(nome);
		return input.touched && input.invalid;
	}
}
